// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1wh8Z","container":"styles_container__22X6y","title":"styles_title__3qd0j","wrapper":"styles_wrapper___HAoV","answer":"styles_answer__1hZau"};